import React, { useState } from "react";
import { Col, Media, Row, Button } from "react-bootstrap";
import Modal from "../../components/common/modal";
import { useForm, Controller } from "react-hook-form";
import Spinner from "../common/spinner";
import PatientChip from "./patientChip";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useShareCoupon } from "../../Hooks/useCoupons";
import { useQueryClient } from "react-query";
import swal from "sweetalert";
import SearchInput, { createFilter } from "react-search-input";
import { Link, Element } from "react-scroll";

const CouponsList = ({ data, isFetching, careGroupData }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const queryClient = useQueryClient();
  const [show, setShow] = useState(false);
  const [selectedCoupon, setSelectedCoupon] = useState({ count: 0 });
  const [checkedValues, setCheckedValues] = useState([]);

  const aToZarray = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ];
  const KEYS_TO_FILTERS = ["patient_name", "patient_number", "email"];
  const filteredData = careGroupData?.all_patients?.length
    ? careGroupData?.all_patients.filter(
      createFilter(searchTerm, KEYS_TO_FILTERS)
    )
    : [];

  // loop for filter data starting latter
  const filteredDataAlfaBet = filteredData.map((obj) => {
    let rObj = obj.patient_name.charAt(0).toLowerCase();
    return rObj;
  });

  // after finding starting latter and short no repete
  const noRepetFilteredDataAl = [];
  for (const element of filteredDataAlfaBet) {
    if (noRepetFilteredDataAl.indexOf(element) === -1) {
      noRepetFilteredDataAl.push(element);
    }
  }
  noRepetFilteredDataAl.sort(function (a, b) {
    return a - b;
  });



  let noRepetFilteredDataAlfaBet = noRepetFilteredDataAl.sort(
    new Intl.Collator("en", { numeric: true, sensitivity: "accent" }).compare
  );

  //filterd data and arrage in one array
  let subFilteredData = [];
  for (let i = 0; i < noRepetFilteredDataAlfaBet.length; i++) {
    let element = noRepetFilteredDataAlfaBet[i];
    let result = filteredData.filter((f) =>
      f.patient_name.toLowerCase().startsWith(element)
    );
    subFilteredData.push(result);
  }

  const handleClose = () => {
    setSelectedCoupon({ count: 0 });
    setCheckedValues([]);
    setSearchTerm("");
    setShow(false);
    // setCheckedValuesError(false);
  };
  const handleShow = (ids) => {
    setSelectedCoupon(ids);
    setShow(true);
  };
  const validationSchema = yup.object().shape({
    patient_info: yup
      .array()
      .min(1, "Atleast 1 Patient must be selected")
      .max(selectedCoupon?.count || 0),
  });
  const { handleSubmit, errors, control, getValues, setValue, setError } =
    useForm({
      mode: "onChange",
      resolver: yupResolver(validationSchema),
    });

  const mutation = useShareCoupon();

  const intersect = (a, b) => {
    let setB = new Set(b);
    return [...new Set(a)].filter((x) => setB.has(x));
  };

  const onSubmit = (payload) => {
    const patientsWithCoupons = data.shared_coupon_detail
      .filter(
        (item) =>
          item.coupon_code === selectedCoupon.coupon_code &&
          item.short_description === selectedCoupon.short_description
      )
      .map((row) => row.patient_info)
      .flat()
      .map((item) => item.patient_id);
    const selectedPatient = payload.patient_info
      .map((item) => JSON.parse(item))
      .map((row) => row.patient_id);
    const shared = intersect(patientsWithCoupons, selectedPatient);
    if (shared.length) {
      const names = shared
        .map((id) =>
          careGroupData.all_patients.filter((item) => item.patient_id === id)
        )
        .flat()
        .map((item) => item.patient_name)
        .join(",");
      setError("patient_info", {
        type: "exists",
        message: `Coupon is already shared with ${names}`,
      });
    } else {
      mutation.mutate(
        { payload, selectedCoupon },
        {
          onSuccess: () => {
            handleClose();
            showSuccess();
            queryClient.invalidateQueries("fetchCoupons");
          },
        }
      );
    }
  };

  const showSuccess = () => {
    swal({
      title: "Coupon Shared Successfully",
      text: "The Coupons has been shared with the patient(s)",
      icon: "success",
      button: "okay",
      className: "custom-swal",
    });
  };

  const handleSelected = (selectedItem) => {
    const newNames = checkedValues?.includes(selectedItem)
      ? checkedValues?.filter((item) => item !== selectedItem)
      : [...(checkedValues ?? []), selectedItem];

    // if(newNames.length <=2){
    setCheckedValues(newNames);
    setValue(
      "patient_info",
      newNames.map((row) => JSON.stringify(row))
    );
    // setCheckedValuesError(false)
    // } else{
    // setCheckedValuesError(true)
    // }
    return newNames;
  };

  const handleRemove = (index) => {
    const filteredItems = checkedValues
      .slice(0, index)
      .concat(checkedValues.slice(index + 1, checkedValues.length));
    setCheckedValues(filteredItems);
    setValue(
      "patient_info",
      filteredItems.map((row) => JSON.stringify(row))
    );
    // if(filteredItems.length === 1){
    //   setCheckedValuesError(false)
    // }
  };

  if (isFetching) return <Spinner />;

  return (
    <>
      {data.all_coupons.length > 0 ? (
        <Row>
          {data.all_coupons?.map((item, index) => (
            <Col md={4} key={index}>
              <div className="coupons-box">
                <div className="top-content">
                  <div className="left-tag">{item.count} Left</div>
                  <p>Coupon Code</p>
                  <span>{item.coupon_code}</span>
                </div>
                <div className="bottom-content">
                  <h3>{item.short_description}</h3>
                  <p>{item.long_descrption}</p>
                  <button
                    className="primary-cta-button rounded-pill py-2"
                    onClick={() => {
                      handleShow(item);
                    }}
                    style={{ pointerEvents: "initial" }}
                  >
                    <i className="fa fa-share" aria-hidden="true"></i> Share
                  </button>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      ) : (
        <p style={{ height: "100vh" }}>No Patient Coupons Found</p>
      )}
      <Modal
        show={show}
        onHide={handleClose}
        className="share-reward-modal custom-modal paddingTop0"
        title={"Share Reward"}
      >
        {mutation.isLoading ? (
          <Spinner />
        ) : (
          <>
            <div className="search-input">
              <SearchInput onChange={setSearchTerm} />
              <Button className="primary-cta-button rounded-pill py-2">
                <i className="fa fa-search" aria-hidden="true"></i>
              </Button>
            </div>
            <PatientChip
              control={control}
              values={getValues}
              handleRemove={handleRemove}
            />
            {/* <PatientChip data={filteredData} selected_data={Array.from(checkedPatient)} /> */}
            <div
              className="contact_list_and_key"
              style={{ position: "relative" }}
            >
              <Element id="containerElement" className="contact-list-main">
                {filteredData?.length ? (
                  subFilteredData.map((superFilteredDataItem, index) => (
                    <Element
                      key={index}
                      name={`first_letter_${superFilteredDataItem[0].patient_name
                        .charAt(0)
                        .toLowerCase()}`}
                    >
                      {superFilteredDataItem.map((item, index) => (
                        <Media>
                          <label className="custom-check">
                            <Controller
                              name={"patient_info"}
                              control={control}
                              render={() => (
                                <input
                                  type="checkbox"
                                  checked={checkedValues.includes(item)}
                                  onChange={() => handleSelected(item)}
                                />
                              )}
                            />
                            <span className="checkmark"></span>
                          </label>
                          <Media.Body>
                            <div className="name-gmail ">
                              <h6 className="text-dark">{item.patient_name}</h6>
                              <p>
                                {item.email ? (
                                  <>
                                    {item.email}, {item.patient_number}
                                  </>
                                ) : (
                                  <>{item.patient_number}</>
                                )}
                              </p>
                            </div>
                          </Media.Body>
                        </Media>
                      ))}
                    </Element>
                  ))
                ) : (
                  <p>No Result Found</p>
                )}
              </Element>
              <div className="listAlfaBet">
                <ul
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    listStyle: "none",
                    justifyContent: "space-around",
                  }}
                >
                  {filteredData?.length
                    ? aToZarray.map((aToZeach) => (
                      <li id="index">
                        <Link
                          activeClass="active"
                          to={`first_letter_${aToZeach.toLowerCase()}`}
                          spy={true}
                          smooth={true}
                          containerId="containerElement"
                        >
                          {aToZeach}
                        </Link>
                      </li>
                    ))
                    : ""}
                </ul>
              </div>
            </div>
            {errors &&
              errors.patient_info &&
              errors.patient_info.type == "min" ? (
              <p style={{ color: "red" }}> {errors.patient_info.message}</p>
            ) : null}
            {errors &&
              errors.patient_info &&
              errors.patient_info.type == "max" ? (
              <p style={{ color: "red" }}>
                {" "}
                You can only share {selectedCoupon.count} coupons
              </p>
            ) : null}
            {errors.patient_info && errors.patient_info.type === "exists" ? (
              <p style={{ color: "red" }}>{errors.patient_info.message}</p>
            ) : null}

            <div style={{ textAlign: "center" }}>
              {/* <p style={{height:"30px", paddingTop: "10px", textAlign: "left"}}>
                {checkedValuesError ? 
                  <span style={{color: "#DA1346", fontSize:"14px"}}>You can only share 02 coupons</span>
                  : ""
                }
              </p> */}
              <button
                className="primary-cta-button rounded-pill py-2 send-reward-btn"
                onClick={handleSubmit(onSubmit)}
              >
                Send Reward
              </button>
            </div>
          </>
        )}
      </Modal>
    </>
  );
};

export default CouponsList;
